import {useCallback} from 'react';


import {trackUserEvents} from 'src/openapi/admin/apis/TrackUserEventApi';
import {UserEventCode} from 'src/openapi/admin/models/UserEventCode';
import {useAppDispatch} from 'src/store/hooks';

export const useEditTableEventTracking = () => {
    const appDispatch = useAppDispatch();

    const selectLayoutSubmit = useCallback(({templateType, place}: {templateType: string, place: string}) => {
        appDispatch(trackUserEvents({
            userEventRequest: {
                userEvent: {
                    eventCode: UserEventCode.ET_LAYOUT_SELECT,
                    templateType,
                    place,
                },
            },
        }));
    }, [appDispatch]);

    const createLayoutSubmit = useCallback((
        {submit, success, place}: {submit: boolean, success: boolean, place: string},
    ) => {
        appDispatch(trackUserEvents({
            userEventRequest: {
                userEvent: {
                    eventCode: UserEventCode.ET_CREATE_LAYOUT_SUBMIT,
                    submit,
                    success,
                    place,
                },
            },
        }));
    }, [appDispatch]);

    const renameLayoutSubmit = useCallback((
        {submit, success, place}: {submit: boolean, success: boolean, place: string},
    ) => {
        appDispatch(trackUserEvents({
            userEventRequest: {
                userEvent: {
                    eventCode: UserEventCode.ET_RENAME_LAYOUT_SUBMIT,
                    submit,
                    success,
                    place,
                },
            },
        }));
    }, [appDispatch]);

    const removeLayoutSubmit = useCallback((
        {submit, success, place}: {submit: boolean, success: boolean, place: string},
    ) => {
        appDispatch(trackUserEvents({
            userEventRequest: {
                userEvent: {
                    eventCode: UserEventCode.ET_REMOVE_LAYOUT_SUBMIT,
                    submit,
                    success,
                    place,
                },
            },
        }));
    }, [appDispatch]);

    const editColumnsSubmit = useCallback((
        {submit, success, place}: {submit: boolean, success: boolean, place: string},
    ) => {
        appDispatch(trackUserEvents({
            userEventRequest: {
                userEvent: {
                    eventCode: UserEventCode.ET_EDIT_COLUMNS_SUBMIT,
                    submit,
                    success,
                    place,
                },
            },
        }));
    }, [appDispatch]);

    const editSortingSubmit = useCallback((
        {submit, success, place}: {submit: boolean, success: boolean, place: string},
    ) => {
        appDispatch(trackUserEvents({
            userEventRequest: {
                userEvent: {
                    eventCode: UserEventCode.ET_EDIT_SORTING_SUBMIT,
                    submit,
                    success,
                    place,
                },
            },
        }));
    }, [appDispatch]);

    return {
        selectLayoutSubmit,
        createLayoutSubmit,
        renameLayoutSubmit,
        removeLayoutSubmit,
        editColumnsSubmit,
        editSortingSubmit,
    };
};
